import React from "react";
import ViewTravelPartner from "../component/TravelPartner/ViewTravelPartner";

const TravelPartner = () => {
  return (
    <>
      <ViewTravelPartner />
    </>
  );
};

export default TravelPartner;
